import { post } from './apiUtils';

const defaultUrl = '/InciList/';

export default {
  saveInciList: data => post(defaultUrl, data),
};
